import React from "react";

import { IEditDataCellProps } from "components/dashboard/product-template-table/utils/interfaces";
import { useHasPermissions } from "hooks/useHasPermissions";
import { Button } from "primereact/button";
import { confirmPopup } from "primereact/confirmpopup";
import { T } from "services/lang/LanguageService";
import "./CustomIconButton.scss";

export default function EditDataCell(props: IEditDataCellProps) {
  const hasPermission = useHasPermissions("easas.product_templates.signature-override");

  const acceptDelete = () => {
    props.onClickDelete(props.index);
  };

  const acceptCopy = () => {
    props.onClickCopy(props.index);
  };

  const reject = () => {};

  const deleteConfirm = (event: any) => {
    confirmPopup({
      target: event.currentTarget,
      message: T("confirm-dialog.do-you-want-to-delete-this-entry"),
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: acceptDelete,
      reject,
    });
  };

  const copyConfirm = (event: any) => {
    confirmPopup({
      target: event.currentTarget,
      message: T("confirm-dialog.do-you-want-to-copy-this-entry"),
      icon: "pi pi-copy",
      acceptClassName: "p-button-success",
      accept: acceptCopy,
      reject,
    });
  };

  return (
    <span
      className="template-table-edit-buttons"
      style={{
        display: "flex",
        flexWrap: "nowrap",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {props.isInEditMode ? (
        <>
          <div>
            <i className="pi pi-save text-blue-400 pl-2" onClick={() => props.onClickSave(props.index)} />
          </div>
          <div>
            <i className="pi pi-times text-red-500 pl-2" onClick={() => props.onClickCancel(props.index)} />
          </div>
        </>
      ) : (
        <>
          {/*  Don't use div as parent of primereact button with showOnDisabled=ture as it causes crash on click,
           using span parent is workaround for it
            */}
          <span>
            <Button
              icon="pi pi-pencil"
              className="p-button-text"
              onClick={() => props.onClickEdit(props.index)}
              disabled={!hasPermission && !!props.signedBy}
              tooltip={
                props.signedBy
                  ? T("message.entry-locked-editing-disabled-signed-by", {
                      signedBy: props.signedBy,
                    })
                  : ""
              }
              tooltipOptions={{ showOnDisabled: true }}
            />
          </span>
          <span>
            <i className="pi pi-copy text-blue-400" onClick={copyConfirm} />
          </span>
        </>
      )}
      {props.deletable && <i className="pi pi-trash text-red-500 px-2" onClick={deleteConfirm} />}
    </span>
  );
}
